import React, {useEffect, useState} from 'react'
import TextField from '@material-ui/core/TextField'
import {makeStyles} from '@material-ui/core/styles';
import {changeFilter} from "../../actions/FilterActions";
import {useDispatch, useSelector} from "react-redux";
import Paper from "@material-ui/core/Paper/Paper";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import {format, formatISO, parseISO} from "date-fns";

const useStyles = makeStyles(theme => {

    return ({

              textField: {
                minWidth: 80,
                marginLeft: theme.spacing(1),
                marginRight: theme.spacing(1),
              },
              container: {
                marginBottom: theme.spacing(1) * 2,
                },
                paperFilter: {
                    padding: theme.spacing(1) * 2,
                },
                formDatas: {
                    display: 'flex',
                    flexDirection: 'column',
                    flexWrap: 'nowrap'
                }
            });
}) ;


/*
const mapDispatchToProps = ({
    changeFilter,
    onChangeFilter,
    onSubmitFilter,
    getProductionStatisticsByStation,
    getSOProductionStatistics

})
 */


const FiltersSectionColumn  = (
                                   props
                               ) => {
    const classes = useStyles();
    const periodMin =  useSelector( state => {
        const d = parseISO(state.filter.periodMin)
        return format(d,"yyyy-MM-dd'T'HH:mm:ss")
    });
    const periodMax =  useSelector( state =>   {
        const d = parseISO(state.filter.periodMax)
        return format(d,"yyyy-MM-dd'T'HH:mm:ss")
    });

    const dispatch  = useDispatch();

    const [tfperiodMin, settfPeriodMin] = useState(periodMin);
    const [tfperiodMax, settfPeriodMax] = useState(periodMax);




    const handleSubmit = (event) => {
        event.preventDefault();
        dispatch(changeFilter({ "periodMin": tfperiodMin, "periodMax": tfperiodMax }));
        if (props.onFilterClick) { props.onFilterClick() }

    }
    const setMin = (d) => {
        console.log(d);

        settfPeriodMin(formatISO(parseISO(d)));
    }

    const setMax = (d) => {
        console.log(d);

        settfPeriodMax(formatISO(parseISO(d)));
    }


    return (

      <div className={classes.container}>
          <Paper className={classes.paperFilter} style={{ backgroundColor: 'transparent'}}   boxShadow={4}>
              <Grid container>
                 <Grid item container className={classes.formDatas} xs={12} lg={12} xl={12}>
                    {/*<form noValidate>*/}
                        <TextField
                            id="periodMin"
                            label="Inicio"
                            type="datetime-local"
                            defaultValue={periodMin}
                            format="DD/MM/YYYY HH:mm:ss"
                            className={classes.textField}
                            onChange={(e) => setMin(e.target.value)}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                        <TextField
                            id="periodMax"
                            label="até"
                            type="datetime-local"
                            defaultValue={periodMax}
                            className={classes.textField}
                            onChange={(e) => setMax(e.target.value)}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                        {/*<Button variant="contained" color="secondary" type="submit" onClick={handleSubmit} style={{verticalAlign:'center'}}>=></Button>*/}
                    {/*</form>*/}
                 </Grid>
                  <Grid item xs={1} lg={1} xl={1}>
                      { props && props.loading && <CircularProgress/>}
                  </Grid>
              </Grid>
          </Paper >
      </div>
    )
  }

export default (FiltersSectionColumn);


